module.exports = __webpack_public_path__ + "img/head.be5030ca.webp";